export const CONNEXION_URL = 'https://api.monkolis.com/user-mgt';
export const BACK_OFFICE_URL = 'https://api.monkolis.com/backoffice';